<template>
    <div class="grid grid-cols-1">
        <InputText :inputLbl="lbl.appointment.claimForm.driverName" :errorInfo="errInfo[0]"
            v-model:inputValue="model.driverName" :isSubmitted="isSubmitted" :isShowError="true"
            :showErrorOnPlaceholder="true" isTextOnly :isDisable="isDisable" />

        <InputContactNumber :inputLbl="lbl.appointment.claimForm.driverContactNo" :errorInfo="errInfo[1]" delimeter="-"
            :minLength="12" :maxLength="12" v-model:inputValue="model.driverContactNumber" :isSubmitted="isSubmitted"
            :showErrorOnPlaceholder="true" :isShowError="true" :isDisable="isDisable"/>

        <DateTimePicker
            :inputLbl="{ date: lbl.appointment.claimForm.appointDate, time: lbl.appointment.claimForm.appointTime }"
            :errorInfo="errInfo[2]" :lowerLimit="minDate" v-model:inputValue="model.appointmentDate"
            v-model:time="model.appointmentTime" :isSubmitted="isSubmitted" :isShowError="true" :isDisabled="isDisable"/>

        <InputText :inputLbl="lbl.appointment.claimForm.appointLocation" :errorInfo="errInfo[3]"
            v-model:inputValue="model.location" :isSubmitted="isSubmitted" :isShowError="true"
            :showErrorOnPlaceholder="true" :isDisable="isDisable"/>

        <div class="mt-6">
            <MainButton size="lg" block :disabled="!isCanSubmit || isDisable" @click="submitForm()">
                แจ้งเคลมนัดหมาย
            </MainButton>
        </div>
    </div>
</template>

<script>
import { FormHelper } from '@/helper/FormHelper';
import { computed, defineComponent, inject, ref, unref, watch } from 'vue';
import { AppointmentClaimModel } from "../model/AppointmentClaimModel"
// component
import InputText from '@/components/Input/label/InputText.vue';
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
import DateTimePicker from "../component/DateTimePicker.vue"
import MainButton from '@/components/Button/MainButton.vue';
import { DateTime } from 'luxon';

export default defineComponent({
    components: {
        InputText,
        InputContactNumber,
        MainButton,
        DateTimePicker
    },
    props: {
        customer: {
            type: Object,
            default: null
        },
        isDisable: {type: Boolean, default: true},
    },
    emits: ["onSubmit"],
    setup: function (props, ctx) {
        const { lbl } = inject("LocaleStore")
        const errInfo = ref(FormHelper.genErrorInfo(4))
        const model = ref(new AppointmentClaimModel())
        const isSubmitted = ref(false)

        const currentDt = DateTime.now()
        const minDate = currentDt.toJSDate()

        if (props.customer != null) {
            const customerObj = unref(props.customer)
            model.value.driverName = `${customerObj.first_name} ${customerObj.last_name}`
            model.value.driverContactNumber = customerObj.mobile_no
        }

        const isCanSubmit = computed(() => {
            // console.log(locationValid.value, isSubmitted.value)
            if (!FormHelper.validate(errInfo.value) && isSubmitted.value) {
                return false
            }
            return true
        })

        const setDefaultDate = function () {
            let tomorrow = DateTime.now().startOf("day").plus({ days: 1 })

            model.value.appointmentDate = tomorrow.toJSDate()
            model.value.appointmentTime = { hours: 9, minutes: 0 }
        }

        const submitForm = function () {
            isSubmitted.value = true

            if (FormHelper.validate(errInfo.value)) {
                ctx.emit("onSubmit", model.value)
            }
        }

        setDefaultDate()

        watch(model, () => {
            // console.log(model.value)
        }, {
            deep: true
        })

        return {
            lbl,
            errInfo,
            model,
            isSubmitted,
            isCanSubmit,
            minDate,
            submitForm
        }
    },
})
</script>

